import React from 'react'
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select'
import { InfoIcon } from '@/components/icons'

// Facebook Marketing API valid call-to-action types
// Reference: https://developers.facebook.com/docs/marketing-api/reference/ad-creative-link-data-call-to-action/
const CTA_OPTIONS = [
    { value: 'APPLY_NOW', label: 'Apply Now' },
    { value: 'BOOK_NOW', label: 'Book Now' },
    { value: 'CONTACT_US', label: 'Contact Us' },
    { value: 'GET_OFFER', label: 'Get Offer' },
    { value: 'GET_QUOTE', label: 'Get Quote' },
    { value: 'GET_SHOWTIMES', label: 'Get Showtimes' },
    { value: 'LEARN_MORE', label: 'Learn More' },
    { value: 'LISTEN_NOW', label: 'Listen now' },
    { value: 'ORDER_NOW', label: 'Order Now' },
    { value: 'PLAY_GAME', label: 'Play Game' },
    { value: 'REQUEST_TIME', label: 'Request Time' },
    { value: 'SHOP_NOW', label: 'Shop Now' },
    { value: 'SIGN_UP', label: 'Sign Up' },
    { value: 'SUBSCRIBE', label: 'Subscribe' },
    { value: 'WATCH_MORE', label: 'Watch More' }
]

// CTA types compatible with Facebook lead gen forms (lead_gen_form_id)
const LEAD_FORM_COMPATIBLE_CTA_VALUES = new Set([
    'APPLY_NOW',
    'BOOK_NOW',
    'GET_OFFER',
    'GET_QUOTE',
    'LEARN_MORE',
    'SIGN_UP',
    'SUBSCRIBE',
])

export const CTADropdown = ({
    value = 'LEARN_MORE',
    onChange,
    disabled = false,
    tooltip = null,
    leadFormMode = false,
}) => {
    const options = leadFormMode
        ? CTA_OPTIONS.filter((opt) => LEAD_FORM_COMPATIBLE_CTA_VALUES.has(opt.value))
        : CTA_OPTIONS
    return (
        <div className="tw:mb-6">
            <div className="tw:flex tw:items-center tw:gap-2 tw:mb-3">
                <label className="tw:!text-sm tw:!font-bold tw:text-white">
                    Call To Action
                </label>
                {tooltip ? (
                    <div className="tw:group tw:relative">
                        <InfoIcon size={20} className="tw:cursor-help" />
                        <div className="tw:absolute tw:bottom-full tw:left-0 tw:mb-2 tw:p-2 tw:bg-black tw:text-white tw:text-xs tw:rounded tw:opacity-0 tw:group-hover:opacity-100 tw:transition-opacity tw:pointer-events-none tw:z-20 tw:w-64">
                            {tooltip}
                        </div>
                    </div>
                ) : (
                    <InfoIcon size={20} className="tw:cursor-help" />
                )}
            </div>
            <Select value={value} onValueChange={onChange} disabled={disabled}>
                <SelectTrigger
                    className="tw:file:text-foreground tw:text-muted-foreground tw:selection:bg-primary tw:selection:text-primary-foreground tw:dark:bg-background tw:border-[#3B5168] tw:flex tw:h-[40px] tw:w-full tw:min-w-0 tw:rounded-xs tw:border tw:bg-transparent tw:px-3 tw:py-1 tw:!text-sm tw:shadow-xs tw:transition-[color,box-shadow] tw:outline-none tw:disabled:pointer-events-none tw:disabled:cursor-not-allowed tw:disabled:opacity-50 tw:focus-visible:border-blue-500 tw:focus-visible:border-[1px] tw:aria-invalid:ring-destructive/20 tw:dark:aria-invalid:ring-destructive/40 tw:aria-invalid:border-destructive"
                >
                    <SelectValue placeholder="Select call to action" />
                </SelectTrigger>
                <SelectContent className="tw:bg-gray-800 tw:border-gray-600">
                    {options.map((option) => (
                        <SelectItem
                            key={option.value}
                            value={option.value}
                            className="tw:text-white hover:tw:bg-gray-700 focus:tw:bg-gray-700"
                        >
                            {option.label}
                        </SelectItem>
                    ))}
                </SelectContent>
            </Select>
        </div>
    )
}

// Helper function to get display label from API value
export const getCTALabel = (apiValue) => {
    const option = CTA_OPTIONS.find(opt => opt.value === apiValue)
    return option ? option.label : apiValue
}